export default __webpack_public_path__ + "static/media/logo.38239c98.png";